"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;

var primitives_1 = require("./primitives");

var _primitives_1$primiti = primitives_1.primitives,
    fontSize = _primitives_1$primiti.fontSize,
    fontWeight = _primitives_1$primiti.fontWeight;
exports.tokens = {
  "3xl": Object.assign(Object.assign({}, fontSize["3xl"]), {
    fontFamily: "heading",
    fontWeight: fontWeight.medium
  }),
  "2xl": Object.assign(Object.assign({}, fontSize["2xl"]), {
    fontFamily: "heading",
    fontWeight: fontWeight.medium
  }),
  xl: Object.assign(Object.assign({}, fontSize.xl), {
    fontFamily: "heading",
    fontWeight: fontWeight.medium
  }),
  lg: Object.assign(Object.assign({}, fontSize.lg), {
    fontFamily: "heading",
    fontWeight: fontWeight.medium
  }),
  md: Object.assign(Object.assign({}, fontSize.md), {
    fontFamily: "heading",
    fontWeight: fontWeight.medium
  }),
  base: Object.assign(Object.assign({}, fontSize.md), {
    fontFamily: "body",
    fontWeight: fontWeight.normal
  }),
  sm: Object.assign(Object.assign({}, fontSize.sm), {
    fontFamily: "body",
    fontWeight: fontWeight.normal
  }),
  xs: Object.assign(Object.assign({}, fontSize.xs), {
    fontFamily: "body",
    fontWeight: fontWeight.normal
  }),
  code: Object.assign(Object.assign({}, fontSize.sm), {
    fontFamily: "code",
    fontWeight: fontWeight.normal
  })
};